module.exports = __webpack_public_path__ + "img/14.12957ad9.svg";